import React from 'react';

const BlankPage = () => {
  return <div aria-hidden="true" />;
};

export default BlankPage;
